import { useTranslation } from 'react-i18next';
import { Form } from 'react-final-form';
import {
  SplitBillQrCodeContainer,
  TitleContainer,
  Title,
  SubTitle,
  QrCodeContainer,
  ConfirmSplitButton,
} from './index.view';
import QRCode from 'react-qr-code';
import CopyToClipBoard from 'components/CopyToClipBoard';
import { useMemo } from 'react';
import { SESSION } from 'constants/enum/session';

const SpiltBillQrCode = () => {
  const { t } = useTranslation();
  const token = sessionStorage?.getItem(SESSION.TOKEN) ?? '';
  const splitToken = sessionStorage?.getItem(SESSION.HEAD_SPLIT_TOKEN) ?? '';

  const url = useMemo(
    () => `${window.location.origin}/${splitToken || token}/split-bill-by-item`,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  return (
    <Form
      onSubmit={() => {}}
      render={({ handleSubmit, submitting }) => (
        <form onSubmit={handleSubmit}>
          <TitleContainer>
            <Title>{t('spiltBillQrCodeTitle')}</Title>
            <SubTitle>{t('spiltBillQrCodeSubTitle')}</SubTitle>
          </TitleContainer>

          <SplitBillQrCodeContainer>
            <QrCodeContainer>
              <QRCode value={url} size={275} />
            </QrCodeContainer>

            <CopyToClipBoard value={url} />

            <ConfirmSplitButton
              loading={submitting}
              disabled={submitting}
              fullWidth
              paylo
              variant="contained"
              type="submit"
              loadingColor="#fff"
              onClick={() => window.open(url, '_self')}
            >
              {t('continueSplit')}
            </ConfirmSplitButton>
          </SplitBillQrCodeContainer>
        </form>
      )}
    />
  );
};

export default SpiltBillQrCode;
